import { useEffect, useState } from 'react';
import { PLAN_MAP_PERMISSION } from '@/config';
import { useSessionStore } from './useSessionStore';
import { useSubscriptionStore } from '@/state/subsription-store';
import { useDocumentVisibility } from 'ahooks';

export const useAuthCheck = () => {
  const { session, fetchData } = useSessionStore();
  const { setPermission } = useSubscriptionStore();
  const { isLoaded, user } = session;
  const [authChecked, setAuthChecked] = useState(false);

  const documentVisibility = useDocumentVisibility();

  useEffect(() => {
    if (documentVisibility === 'visible') {
      fetchData();
    }
  }, [documentVisibility]);

  useEffect(() => {
    if (isLoaded) {
      if (!user.id) {
        // can not use navigate cause login is not migrated to jen-beta-ui
        window.location.replace('/login');
      } else {
        const loginCallbackUrl = window.sessionStorage.getItem('loginCallbackUrl');
        if (user.id && loginCallbackUrl) {
          window.sessionStorage.removeItem('loginCallbackUrl');
          window.location.href = loginCallbackUrl;
          return;
        }
      }
      setAuthChecked(true);
    }

    if (user?.plan?.key) {
      const permission = PLAN_MAP_PERMISSION?.[user.plan.key as any] || {};
      setPermission(permission);
    }
  }, [isLoaded, user.id]);

  return {
    isAuth: Boolean(user.id) && authChecked,
  };
};

export const checkAuthAndRedirect = () => {
  const { session } = useSessionStore.getState();
  const { user } = session;

  if (!user?.id) {
    window.location.replace('/login');
    return false;
  }

  return true;
};
